import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import { invoiceStateData } from 'mocks/mockData/InvoiceStateData';

export const updateInvoiceStateHandler: RestHandler[] = [
  rest.post(PATHS.getInvoiceStatePath('*', 'POSTED'), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(invoiceStateData))
  ),
  rest.post(PATHS.getInvoiceStatePath('*', 'APPROVED'), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(invoiceStateData))
  ),
  rest.post(PATHS.getInvoiceStatePath('*', 'AUTHORIZED'), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(invoiceStateData))
  )
];
